import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../../../styles/constants';

export const useStyles = makeStyles(theme => ({
	root: {
		minWidth: props => props.width,
		width: props => props.width,
		marginTop: 2,
		marginBottom: 0,
		overflow: 'hidden',
		'& .MuiFilledInput-root': {
			backgroundColor: COLORS.BACKGROUND_INPUT,
			'&:hover': {
				backgroundColor: COLORS.BACKGROUND_INPUT_HOVER
			}
		},
		'& .MuiFilledInput-inputMarginDense': {
			padding: 5,
			paddingRight: 2
		},
		'& .MuiFilledInput-underline': {
			'&:before': {
				borderBottom: 0
			},
			'&:hover:before': {
				borderBottom: 0
			}
		},
		'& .MuiFilledInput-adornedStart': {
			paddingLeft: 7
		},
		'& .MuiFilledInput-adornedEnd': {
			paddingRight: 7
		},
		'& .MuiInputBase-root': {
			fontSize: theme.typography.body2.fontSize
		}
	}
}));

export const useInputAdornmentStyles = makeStyles({
	filled: {
		margin: '0 !important'
	}
});
